// src/shared/api/booking-api.ts
import axios from 'axios';

const BOOKING_API_BASE_URL = (
    process.env.REACT_APP_BOOKING_API_URL || 'https://booking.vkksu.com/api'
).replace(/\/+$/, '');

// Создаем отдельный инстанс для BookingSystem
export const bookingClient = axios.create({
    baseURL: BOOKING_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Добавляем перехватчик для токена, если авторизация нужна
bookingClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token'); // Или ваше хранилище токенов
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export interface Slot {
    start: string;
    end: string;
    price: number;
}

export interface BookingResponse {
    date: string;
    slots: Slot[];
}

export interface BookingRequest {
    start_time: string;
    client_email: string;
    client_phone: string;
    booking_type: string;
}

export interface Booking {
    id: number;
    start_time: string;
    end_time: string;
    booking_type: string;
    consultant_name: string;
    status: string;
    status_display: string;
}

export interface PaymentResponse {
    url: string;
}

export const bookingApi = {
    // Получить слоты на конкретную дату
    getSlots: async (date: string) => {
        // GET /api/bookings/slots/?date=2026-02-12
        const response = await bookingClient.get<BookingResponse>('/bookings/slots/', {
            params: { date }
        });
        return response.data;
    },

    // Создать запись (бэкенд DRF возвращает один объект)
    createBooking: async (data: BookingRequest) => {
        return bookingClient.post<Booking>('/bookings/', data);
    },

    // Initiate payment for booking (returns intermediate payment page URL)
    startBookingPayment: async (bookingId: number) => {
        return bookingClient.post<PaymentResponse>(`/payments/start-booking/${bookingId}/`);
    },

    // Start consultation payment - calls main API or payment gateway
    startConsultationPayment: async (bookingId: number, price: number, description: string) => {
        return bookingClient.post<PaymentResponse>(`/payments/start-consultation/`, {
            booking_id: bookingId,
            price,
            description
        });
    },

    // Получить мои бронирования
    getMyBookings: async (email: string) => {
        const response = await bookingClient.get<Booking[]>('/bookings/my-bookings/', {
            params: { email }
        });
        return response.data;
    }
};
